// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"Buttons-module--menuButton--Vvxe3","path":"Buttons-module--path--1oWVT","guide":"Buttons-module--guide--3LqiZ"};